/**
 * Helpers de presentacion de una cuenta de empresa.
 *
 * Varias cuentas comparten nombre ("Cuenta Corriente Banco") y solo se distinguen por la
 * entidad, asi que donde haya que elegir una cuenta hay que mostrar el banco junto al tipo.
 */

const limpiar = (valor) => (typeof valor === 'string' ? valor.trim() : '');

/**
 * "BANCO · Santander" cuando hay entidad, "EFECTIVO" cuando no, "—" cuando no hay nada.
 */
/**
 * Título corto de una cuenta, para las pestañas del cierre de caja.
 *
 * Dos pestañas que dicen "CUENTA CORRIENTE" no se distinguen: el cajero no sabe cuál es
 * Galicia y cuál Santander Rio.
 *
 * Se usa "Banco <entidad>" y NO "Posnet <entidad>": el posnet es un APARATO, la cuenta es
 * donde cae la plata. Confundirlos es justo lo que produjo el "Posnet Galicia" hardcodeado
 * que este slice vino a sacar — y si esa cuenta además recibe una transferencia, "Posnet"
 * pasa a ser mentira. El prefijo sale de `tipo_cuenta`, que ya es un dato.
 */
export const etiquetaCortaCuenta = (cuenta) => {
  const nombre = limpiar(cuenta?.cuenta);
  const banco = limpiar(cuenta?.banco);
  const tipo = limpiar(cuenta?.tipo_cuenta);

  // Sin entidad cargada, "Banco" pelado no le dice nada a nadie: mejor el nombre de la cuenta.
  if (tipo === 'BANCO' && banco) return `Banco ${banco}`;

  return nombre || banco || '—';
};

export const descripcionCuenta = (cuenta) => {
  const tipo = limpiar(cuenta?.tipo_cuenta);
  const banco = limpiar(cuenta?.banco);

  return [tipo, banco].filter(Boolean).join(' · ') || '—';
};
